import React from 'react';
import { Main as TeliaMain, } from '@telia-front/main';
const Main = (props) => {
    return (React.createElement(TeliaMain, Object.assign({ background: "primary-4" }, props)));
};
export default Main;
